export default __webpack_public_path__ + "static/media/returned-item.ef9f192e.svg";